import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../ThemeContext';

export const ThemeToggle = ({ className = '', size = 'md' }) => {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';
  const dim = size === 'sm' ? 'h-8 w-8' : 'h-9 w-9';
  return (
    <button
      onClick={toggle}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      data-testid='theme-toggle'
      className={`${dim} inline-flex items-center justify-center rounded-full border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1B3A87] transition-colors ${className}`}
    >
      {isDark ? <Sun className='w-4 h-4 text-amber-300' /> : <Moon className='w-4 h-4 text-[#1B3A87]' />}
    </button>
  );
};
